var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-wrapper"},[_c('div',{attrs:{"id":"temperatureChart"}}),_c('div',{attrs:{"id":"voltageChart"}}),_c('div',{attrs:{"id":"sohChart"}})])
}]

export { render, staticRenderFns }